import {
  createCart,
  createCartItem,
  deleteCartItem,
  getCart,
  updateCartItem,
} from '../shopify'
import { makeShopifyId } from '../shopify/utils'
import Cookies from 'js-cookie'

const COOKIE_CART_ID = 'cartId'

export async function getOrCreateCart() {
  const cartId = Cookies.get(COOKIE_CART_ID)
  const cart = cartId ? await getCart(cartId) : await createCart()

  if (!cartId) {
    const newCartId = cart?.id
    if (newCartId) {
      Cookies.set(COOKIE_CART_ID, newCartId)
    }
  }

  return { cartId: cart?.id, cart }
}

export async function addCartItem(variantId: string, quantity: number = 1) {
  if (!variantId) return false

  const { cartId } = await getOrCreateCart()

  if (!cartId) return false

  await createCartItem(cartId, [
    { merchandiseId: makeShopifyId(variantId, 'ProductVariant'), quantity },
  ])

  return true
}

export async function removeCartItem(itemId: string) {
  const cartId = Cookies.get(COOKIE_CART_ID)
  if (!cartId) return false

  await deleteCartItem(cartId, [itemId])

  return true
}

export async function updateItemQuantity(payload: {
  itemId: string
  variantId: string
  quantity: number
}) {
  const cartId = Cookies.get(COOKIE_CART_ID)
  if (!cartId) return false

  const { itemId, variantId, quantity } = payload

  if (quantity === 0) {
    await deleteCartItem(cartId, [itemId])
    return true
  }

  await updateCartItem(cartId, [
    { id: itemId, merchandiseId: variantId, quantity },
  ])

  return true
}
